import { ROTATE_REQUEST, CORE_PICKUP, FETCH_ORDERNOS_PRINT, PRINT_ORDER, PRINT_TRANSFER, STATUS_ERR_MESSAGE, STATUS_NOTICE_MESSAGE, STATUS_UPDATE_STATE_RESET, SUBMIT_CUST_CORE_RESPONSE, VALIDATE_PARTNO, DELETE_ROW_LINE_ORDERNO_DETAIL, ADD_LINE_ORDERNO_DETAIL, SUBMIT_ORDER_RESPONSE, SUBMIT_TRANSFER_RESPONSE, FETCH_INVENTORY_RESET, FETCH_INVENTORY_DETAIL, FETCH_INVENTORY, CUSTOMER_TRANSFER_STATE_RESET, FETCH_CUSTNO_DETAIL, FETCH_CUSTOMERS, ORDER_TRANSFER_STATE_RESET, FETCH_ORDERNO_DETAIL, FETCH_ORDERS, TRANSFERNO_STATE_RESET, FETCH_POSTS, NEW_POSTS, FETCH_LOADTRUCKS, FETCH_LOC, FETCH_TRANSFERS, FETCH_TRANSFERNO_DETAIL, UPDATE_INVENTORY_DETAIL_BIN } from '../actions/actionTypes';
import fmplogo from '../../assets/FMP-Icon.png'
import e from 'cors';

const initialTransferState = {
    items_fetchTransfers: null,
    items_fetchTransfernoDetail: null,
    items_fetchTransfernoDetailHeader: null      
}

const initialOrderState = {
    items_fetchOrders: null,
    items_fetchOrdernoDetail: null,
    items_fetchOrdernoDetailHeader: null,
    items_fetchCorePickup: null, 
    items_addLine: null,
    items_fetchOrdersPrint: {}, 
}

const initialCustomerState = {
    items_fetchCustomers: null,
    items_fetchCustnoDetail: null,
    items_fetchCustCoreBank: null,
    items_fetchCorePickup: null,
}

const initialInventoryState = {
    items_fetchInventory: null,
    items_fetchInventoryDetail: null,
    items_fetchInventoryDetailHeader: null,
    item_updatedBinResponse: null,
}

const initialStatusUpdates  = {
    items_statusNotices: [],
    items_statusErr: [],
    orderServerResponse: {},
    transferServerResponse: {},
    custServerResponse: {} 
 };

const transferReducer = (state = initialTransferState, action) => {
    switch(action.type){
        case FETCH_TRANSFERS:
            return {                
                items_fetchTransfers: action.payload                
            }
        case FETCH_TRANSFERNO_DETAIL:
            return {
                items_fetchTransfernoDetailHeader: action.payload['HEADER'],
                items_fetchTransfernoDetail: action.payload['TRANSFER_PROCESSING_DETAILS']                
            } 
        case PRINT_TRANSFER:
            var transferData = JSON.stringify(state.items_fetchTransfernoDetail);
            var data = JSON.parse(transferData);
            var custdata = JSON.stringify(state.items_fetchTransfernoDetailHeader);
            var add = JSON.parse(custdata);
            console.log(custdata);
            var print = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');

            var printHtmlStart = `
            <html>
            <head>
                <title>Transfer# ${add['TRANSFERNO']}</title>
                <link rel="preload" as="image" href="${fmplogo}" imagesrcset="${fmplogo}">
                
                <style media="print">
                    @page {
                        size: portrait;
                        margin-top: 0.2in;
                        margin-bottom: 0.0in;
                        margin-left: 0.15in;
                        margin-right: 0.15in;            
                    }

                    body {
                        margin: 0px;
                        counter-reset: Page;            
                    }

                    .footerPageNumber::after {
                        content: counter(Page);
                        counter-increment: Page;
                        left: 0;
                        top: 100%;
                        white-space: nowrap;
                    }                      
                </style>  

                <style>
                    .tblTitle {
                        width: 100%;
                    }
                    .tblTitle > tbody > tr > td {
                        padding: 5px 0px;
                        vertical-align: top;
                    }     

                    .tblTitleLogo {
                        width: 10%;
                    }

                    .tblTitleAddrs > tbody > tr > td {
                        padding-top: 3px;
                        vertical-align: top;
                    } 
                    
                    .tblResults {
                        width: 100%;
                    }

                    .tblResults > tbody > tr > td {
                        text-align: center;
                    }     
                    
                    .alternateRowClass {
                        background-color: #d3d3d342;
                    }
                  
                </style>
            </head>
            <body >
            `   

            var printTblTitle = ` 
                <table class="tblTitle" border="0">
                    <tr>
                        <td class="tblTitleLogo">
                            <img src="${fmplogo}" srcset="${fmplogo}" width="142px">
                        </td>
                        <td style="font-size: 14px; padding-left: 21px">
                            <span style="font-size:16px; font-weight:bold;">Factory Motor Parts</span>
                            <br>
                            <br>1380 Corporate Center Curve 
                            <br> Eagan, MN 55031 
                            <br> Phone: 920-224-2445 
                            <br> directshippartner@fmpco.com
                        </td> 
                        <td>
                            <span style="font-size:16px; font-weight:bold;">Transfer No: ${add['TRANSFERNO']}</span>
                        </td>                        
                    </tr>
                    <tr>
                        <td colspan="3">
                            <table>
                                <tr>
                                    <td>
                                        <table class="tblTitleAddrs">
                                            <tr>
                                                <td><b>Shipped From:</b></td>
                                                <td>
                                                    ${add['FROM_NAME']}<br>
                                                    ${add['FROM_ADDR1']}<br>
                                                    ${add['FROM_CITY']}, ${add['FROM_STATE']} ${add['FROM_ZIP']}   
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td colspan="2">
                                        <table class="tblTitleAddrs">
                                            <tr>
                                                <td><b>Shipped To:</b></td>
                                                <td>
                                                    ${add['TO_NAME']}<br>
                                                    ${add['TO_ADDR1']}<br>
                                                    ${add['TO_CITY']}, ${add['TO_STATE']} ${add['TO_ZIP']}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>                        
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            `

            var printTblHeader = `
                <table class="tblResults">
                    <thead>
                        <tr>
                            <th>Line</th>
                            <th>PartNo</th>
                            <th>Desc</th>
                            <th>Bin</th>
                            <th>Transfer Qty</th>
                            <th>Received Qty</th>
                        </tr>
                    </thead>
            `
            var printTblBodyStart = `
                <tbody>
                    <tr>
            `
            print.document.write(printHtmlStart);
            print.document.write(printTblTitle);
            print.document.write(printTblHeader);
            print.document.write(printTblBodyStart);

            var isAlternateRow = false;
            for (var i = 0; i < data.length; i++) {
                
                var colClassName = ''
                if(isAlternateRow === false){
                    colClassName = "alternateRowClass"
                    isAlternateRow = true;
                }
                else{
                    isAlternateRow = false;
                }

                var sdata = JSON.stringify(data[i]);
                var pdata = JSON.parse(sdata);
                console.log(pdata);
                var bin = pdata['DISPLAYEDBIN'] === null ? '' : pdata['DISPLAYEDBIN']

                print.document.write(`<td class="${colClassName}">${pdata['LINE']}</td>`)
                print.document.write(`<td class="${colClassName}">${pdata['PARTNO']}</td>`)
                print.document.write(`<td class="${colClassName}">${pdata['DESCRIPTION']}</td>`)
                print.document.write(`<td class="${colClassName}">${bin}</td>`)
                print.document.write(`<td class="${colClassName}">${pdata['TRANSFERQTY']}</td>`)
                print.document.write(`<td class="${colClassName}">${pdata['USER_INPUT_QTY']}</td>`)
                
                print.document.write(`</tr><tr>`);
                    
            }   

            var printTblBodyEnd = `            
                    </tr>
                </tbody>
            `
           
            print.addEventListener('afterprint', (event) => {
                print.close();
            });

            print.document.write(printTblBodyEnd);
            print.document.write('</table></body></html>');
            print.document.close();
            print.focus();


            setTimeout( function () {                
                print.print();
            }, 250);   

            return {
                ...state
            }             
        case SUBMIT_TRANSFER_RESPONSE:       
            return { 
                ...state
            }               
                    
        case TRANSFERNO_STATE_RESET:
            return initialTransferState;
        default:
            return state;
    }
}

const orderDetailPrintPages = (print, ordernoDetail, orderDetailHeader) => {
    var orderData = JSON.stringify(ordernoDetail);
    var custdata = JSON.stringify(orderDetailHeader);
    var data = JSON.parse(orderData);
    var add = JSON.parse(custdata); 
    
    var countLines = 0; 
    var maxRowsPerPage = 10
    var rowCountPerPage = 0
    var listTotal = data.length
    var expectedTotalPages = Math.floor(listTotal/maxRowsPerPage)+1;
    var pageNumber = 1

    var printHtmlStart = `
    <html>
    <head>
        <title>Print</title> 

        <link rel="preload" as="image" href="${fmplogo}" imagesrcset="${fmplogo}">

        <style media="print">
            @page {
                size: portrait;
                margin-top: 0.2in;
                margin-bottom: 0.0in;
                margin-left: 0.15in;
                margin-right: 0.15in;            
            }

            body {
                margin: 0px;
                counter-reset: Page;            
            }

            .footerPageNumber::after {
                left: 0;
                top: 100%;
                white-space: nowrap;
            }                      
        </style>  

        <style>   
            body {
                font-size: 14px;
                counter-reset: Page;            
                font-family: sans-serif;
            }   
            
            table {
                width: 100%;
                font-size: inherit;
            }        

            table.fmpFrame {
                border: none;
                top: 0px;
                position: relative;
                border-collapse: separate;
                border-spacing: 0px 5px;
            }
            
            .contents {
                width: 100%;
            }      
    
            .tbodyRowData {
                top: 0;
                vertical-align: top;
            }
            
            .footerFormat {
                width: 100%;
                text-align: right;
                font-size: 90%;
                bottom: 0;
                right: 0;
            }
    
            .footerPageNumber::after {
                left: 0;
                top: 100%;
                white-space: nowrap;
            }
    
            .pageBreakTr {
                visibility: collapse;
            }
    
            .pageBreak {
                break-after: page;
            } 
            
            .fmpFrameHeader {
                font-size: 14px;
            }

            .fmpFrameSignature {
                padding-right: 27px;
                width: 50%;
            }

            .signatureTbl {
                border:solid 1px;                                             
            }

            .deliveryTicketTbl {
                border-collapse: collapse;
            }            
            .deliveryTicketTbl > tbody > tr > td{
                border:solid 1px;
                font-weight: bold;
                padding: 2px 0px 5px 3px;
            }
            .deliveryTicketTbl > tbody > tr > td:nth-child(1){                        
                background-color: lightgrey;
            }                    
            .deliveryTicketTbl > tbody > tr > td:nth-child(2){
                width: 57%;
                text-align: center;
            }
            .deliveryTicketTbl > tbody > tr:nth-child(1) > td{
                padding: 4px 2px 7px 0px;
                background-color: white;
                text-align: right;
            }        
                                
            .custInfoTbl {
                font-size: 12px;
            }
            .custInfoTbl_CustnoRow{
                text-align: center;
            }
            .custInfoTbl_CustnoRow > span {
                font-weight: bold;
                font-size: 14px;
            }                    
            .custInfoTbl_AddrRow > tbody > tr > td {
                float: left;
                padding-left: 15px;
            }     
            .custInfo_Addr {
                font-weight: bold;
            }     

            .orderDetailTbl {
                border-collapse: collapse;
                font-weight: bold;
                text-align: center;
                font-size: 12px;
            }       
            .orderDetailTbl > tbody > tr:nth-child(1) > td {
                border: solid 1px;
                background-color: lightgrey;
            }       
            
            .resultsTbl {
                clear: both;
                border-collapse: collapse;
                text-align: left;                                              
            }  
            
            .resultsTbl > tr > td {
                background-color: #80808021; 
                border-top: solid 1px;                        
                border-bottom: solid 1px; 
                padding: 1px 0px;
                height: 37px;  
                max-height: 37px;                    
            }  
                                
            .resultsTbl > tr > td:nth-child(1) {
                text-align: center;
                width: 5%;
                background-color: white;  
                border: none                    
            } 
            .resultsTbl > tr > td:nth-child(2) {
                text-align: left; 
                font-weight: bold;
                padding-left: 2px;
                border-left: solid 1px;
                vertical-align: baseline;
            } 
            .resultsTbl > tr > td:nth-child(3) {
                text-align: center;
                width: 10%;
            } 
            .resultsTbl > tr > td:nth-child(4) {
                text-align: center;
                width: 6%;
            } 
            .resultsTbl > tr > td:nth-child(5) {
                text-align: center;
                width: 6%;
            } 
            .resultsTbl > tr > td:nth-child(6) {
                text-align: center;
                width: 10%;
            } 
            .resultsTbl > tr > td:nth-child(7) {
                text-align: right;
                width: 10%;
                padding-right: 2px;
            } 
            .resultsTbl > tr > td:nth-child(8) {
                text-align: right;
                width: 10%;
                padding-right: 2px;
                border-right: solid 1px;
            } 

            .resultsTblHeader > td {
                font-weight: bold;                        
                font-size: 10px;
                border: solid 1px;
                background-color: lightgrey;
                padding: 3px 3px;
                vertical-align: text-top;
            }

            .paddingVertical {
                padding: 1px 0px;                        
            }

            .pageFooterTbl {
                border-collapse: collapse;
                bottom: 0;                       
            }    
            .pageFooterTbl > tbody > tr > td {
                border: solid 1px;
               
            }                                    
            .pageFooterTbl > tbody > tr:nth-child(1) > td {
                background-color: lightgrey;
                font-weight: bold;
                text-align: center;
                font-size: 10px;
            }
            .pageFooterHazPrompt {
                text-align: left;
                font-size: 8px;
                padding: 3px 0px;
                border: none !important;
            }

            .pagefooternotation {
                font-weight: bold;
                font-size: 10px;
                text-align: right !important;
                border: none !important;
            }

            .prodDescription {
                font-weight: normal;
            }

            .emptyFormattedRow > td {
                padding: 19px 0px !important;
            }
        </style>
    </head>
    <body> `

    var displayShipToAddr2 = ``
    if(add['SHIP_TO_ADDR2'] !== undefined && add['SHIP_TO_ADDR2'] !== ''){
        displayShipToAddr2 = `<br> ${add['SHIP_TO_ADDR2']}`
    }

    var displayBillToAddr2 = ``
    if(add['BILL_TO_ADDR2'] !== undefined && add['BILL_TO_ADDR2'] !== ''){
        displayBillToAddr2 = `<br> ${add['BILL_TO_ADDR2']} `
    }            
        
    var printTblHeader =   
    `   <table class="fmpFrame">
            <thead>
                <tr class="fmpFrameHeader">
                    <td colspan="8">
                        <table>
                            <tr>
                                <td class="fmpFrameSignature">
                                    <table>
                                        <tr>
                                            <td>
                                            <img src="${fmplogo}" srcset="${fmplogo}" width="142px">
                                            </td>
                                            <td style="font-size: 14px; padding-left: 21px">
                                                <span style="font-size:16px; font-weight:bold;">Factory Motor Parts</span>
                                                <br>
                                                <br>1380 Corporate Center Curve 
                                                <br> Eagan, MN 55031 
                                                <br> Phone: 920-224-2445 
                                                <br> directshippartner@fmpco.com
                                            </td>                                        
                                        </tr>
                                        <tr>
                                            <td colspan="2" style="padding: 20px 0 0 10px">
                                                <table class="signatureTbl">                                                      
                                                    <tr>
                                                        <td style="text-align: center; font-size:10px; padding-bottom: 8px;">RECEIVED IN GOOD CONDITION</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-left: 14px; padding-bottom: 8px;">Signature:___________________________</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-left: 14px; padding-bottom: 8px;">Printed:_____________________________</td>
                                                    </tr>                                                                              
                                                    <tr>
                                                        <td style="padding-left: 14px; padding-bottom: 8px;">Battery Cores to collect today? &nbsp;&nbsp;   Y  &nbsp;  /  &nbsp;  N</td>
                                                    </tr>                                                                                           
                                                </table>
                                            </td>
                                        </tr>
                                    </table>                                                            
                                </td>
                                <td>
                                    <table class="deliveryTicketTbl">
                                        <tr>
                                            <td colspan='2'>PICKTICKET</td>                                                                                                                                                                                                                             
                                        </tr>
                                        <tr>
                                            <td>ORDER NO.</td> 
                                            <td>${data[0]['ORDERNO']}</td>                                                                                                                                                                                                                                                                     
                                        </tr>  
                                        <tr>
                                            <td>PARTNER ORDER NO.</td> 
                                            <td></td>                                                                                                                                                                                                                                                                     
                                        </tr>  
                                        <tr>
                                            <td>PAGE</td> 
                                            <td><span class="footerPageNumber">${pageNumber} </span> of ${expectedTotalPages}</td>                                                                                                                                                                                                                                                                     
                                        </tr>  
                                        <tr>
                                            <td>CUSTOMER P.O.</td> 
                                            <td>${add['CUST_PO']}</td>                                                                                                                                                                                                                                                                    
                                        </tr>  
                                        <tr>
                                            <td>DELIVERY DATE</td> 
                                            <td></td>                                                                                                                                                                                                                                                                      
                                        </tr>  
                                        <tr>
                                            <td>TAKEN BY</td> 
                                            <td></td>                                                                                                                                                                                                                                                                    
                                        </tr>  
                                        <tr>
                                            <td>SALES REP OUT</td> 
                                            <td></td>                                                                                                                                                                                                                                                                     
                                        </tr>                                                                                                                                                                                                                                                            
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr class="custInfoTbl">
                    <td colspan="8" style="padding: 0px 0 12px 0px;">
                        <table style="border-spacing: 0;">
                            <tr>
                                <td class="custInfoTbl_CustnoRow">
                                    Customer #: <span>${add['ORDER_CUSTNO']}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="paddingVertical">
                                    <table class="custInfoTbl_td">
                                        <tr>
                                            <td style="width:42%">
                                                <table class="custInfoTbl_AddrRow">
                                                    <tr>
                                                        <td>Ship To:</td>
                                                        <td>
                                                            <span class="custInfo_Addr">
                                                                ${add['SHIP_TO_NAME']} 
                                                                <br> ${add['SHIP_TO_ADDR1']} 
                                                                ${displayShipToAddr2}
                                                                <br> ${add['SHIP_TO_CITY']}, ${add['SHIP_TO_STATE']} ${add['SHIP_TO_ZIP']}
                                                                <br> ${add['PHONE']} 
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td class="paddingVertical"> 
                                                <table class="custInfoTbl_AddrRow">
                                                    <tr>
                                                        <td>Bill To:</td>
                                                        <td>
                                                            <span class="custInfo_Addr">
                                                            ${add['BILL_TO_NAME']} 
                                                            <br> ${add['BILL_TO_ADDR1']}
                                                            ${displayBillToAddr2}
                                                            <br> ${add['BILL_TO_CITY']}, ${add['BILL_TO_STATE']} ${add['BILL_TO_ZIP']} 
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>                                                    
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="paddingVertical">
                                    <table class="orderDetailTbl">
                                        <tr>
                                            <td>INSTRUCTIONS</td>
                                            <td>KEYED</td>
                                            <td>SHIP VIA</td>
                                            <td>REQUEST</td>
                                            <td>ORDERED</td>
                                            <td>TERMS</td>
                                        </tr>
                                        <tr>
                                            <td>${add['INSTRUCTIONS'] === null ? '' : add['INSTRUCTIONS']}</td>
                                            <td>${add['WRITER']}</td>
                                            <td>${add['SHIPVIA']}</td>
                                            <td>${add['CREATED']}</td>
                                            <td>${add['ORDERED']}</td>
                                            <td>${add['TERMS_CODE']}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr class="resultsTblHeader">
                    <td>LINE</br>NO.</td>
                    <td>PRODUCT AND DESCRIPTION</td>
                    <td>BIN</td>
                    <td>QUANTITY</br>ORDERED</td>
                    <td>QUANTITY</br>SHIPPED</td>
                    <td>QTY B.O.</td>
                    <td>UNIT</br>PRICE</td>
                    <td>AMOUNT</br>(NET)</td>
                </tr>

            </thead>
                            
    `

    var printTbodyStart = `
    <tbody class="resultsTbl">
        <tr>  
    `
    var printTblHtmlCloser = `
        </tbody>           
    ` 


    var printTfoot = `
    <footer>
        <tr>
            <td colspan="8">
                <table class="pageFooterTbl">
                    <tr>
                        <td class="pageFooterHazPrompt">
                        Hazardous Material: UN2794, Batteries wet, Filled with Acid - Class 8 - Pg III Corrosive</br>
                        Emergency Contact - 1-800-424-9300 (Contract #CCN15902) UN2796, Battery Fluid, Acid - Class 8 - Pg II Corrosive</br>                                
                        </td>                              
                    </tr>                            
                </table>
            </td>
        </tr>           
    <footer>
    `
    var printPageBreak = `


        <tr class="pageBreakTr">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
                <div class="pageBreak"></div>
                <p />
            </td>
        </tr>              
    `
    print.document.write(printHtmlStart);
    print.document.write(printTblHeader);
    print.document.write(printTbodyStart);
    
    for (var i = 0; i < listTotal; i++) {
        countLines++;
        rowCountPerPage++;

        var sdata = JSON.stringify(data[i])
        var pdata = JSON.parse(sdata)
        
        var bin = '' 
        if(pdata['THIRD_PARTY_BIN_1'] != null) {
            bin = pdata['THIRD_PARTY_BIN_1']
        } 
        print.document.write(`<td>${pdata['LINENO']}</td>`)
        print.document.write(`<td>${pdata['LINE']} ${pdata['PARTNO']}</br><span class="prodDescription">${pdata['DESCRIPTION']}</span></td>`)
        print.document.write(`<td>${bin}</td>`)
        print.document.write(`<td><b>${pdata['ORDERQTY']}</b></td>`)
        print.document.write(`<td>${pdata['SHIPPEDQTY']}</td>`)
        print.document.write(`<td>0</td>`)
        print.document.write(`<td>0.00</td>`)
        print.document.write(`<td>0.00</td>`)

        if( rowCountPerPage % maxRowsPerPage === 0 && rowCountPerPage < listTotal){
            print.document.write(`</tr>`);
            print.document.write(printTfoot); 
            print.document.write(printPageBreak);   
            print.document.write(printTblHtmlCloser); 
            pageNumber = pageNumber + 1;
            print.document.write(printTblHeader);
            print.document.write(printTbodyStart);                    
        }

        if(i < listTotal-1){
            print.document.write(`</tr><tr>`);
        }                                
    }             

    while(countLines % maxRowsPerPage !== 0){
        countLines++;

        print.document.write(`<tr class="emptyFormattedRow">`);
        print.document.write(`<td colspan="8"></td>`)
        print.document.write(`</tr>`);
    }
    
    print.document.write(printTfoot);
    print.document.write(printTblHtmlCloser); 

    var printHtmlEnd = `
    </body>
    </html>                                            
    `

    print.addEventListener('afterprint', (event) => {
        print.close();
    });

    print.document.write(printHtmlEnd);        
    
}

const orderTransferReducer = (state = initialOrderState, action) => {
    switch(action.type){
        case FETCH_ORDERS:
            return {
                items_fetchOrders: action.payload,
            }
        case FETCH_ORDERNO_DETAIL:
            return {
                items_fetchOrdernoDetailHeader: action.payload['HEADER'],
                items_fetchOrdernoDetail: action.payload['ORDER_PROCESSING_DETAILS'],
                items_fetchCorePickup: {}             
            } 
        case PRINT_ORDER:
            var print = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');

            orderDetailPrintPages(print, state.items_fetchOrdernoDetail, state.items_fetchOrdernoDetailHeader)
            print.document.close();
            print.focus();
            setTimeout( function () {                
                print.print();
            }, 250);
                
            return {
                ...state
            }                
        case ADD_LINE_ORDERNO_DETAIL:
            var initialValue_MaxLineno = state.items_fetchOrdernoDetail.length
            var maxLineNo = state.items_fetchOrdernoDetail.reduce( (previousValue, currentValue, currentIndex, array) => {
                let currentValueLineno = 'LINENO' in currentValue ? currentValue['LINENO'] : 0
                return Math.max(previousValue, currentValueLineno);                
            }, initialValue_MaxLineno)

            return {
                ...state,
                items_fetchOrdernoDetail: [ 
                    ...state.items_fetchOrdernoDetail,
                    {
                        'ORDERNO': state.items_fetchOrdernoDetail[0]['ORDERNO'],
                        'USERID': state.items_fetchOrdernoDetail[0]['USERID'],
                        'LINENO': maxLineNo + 1,
                        'PRDID': '',
                        'LINE': '',
                        'PARTNO': '',
                        'ORDERQTY': 0,
                        'SHIPPEDQTY': 0,
                        'ORDER_CUSTID':  state.items_fetchOrdernoDetail[0]['ORDER_CUSTID'],
                        'USER_INPUT_QTY': 1,
                        'QTY_TYPE': 'TO_INSERT'
                    }
                    
                ]                
            } 
        case DELETE_ROW_LINE_ORDERNO_DETAIL:
            var dataIndex = action.payload 
            var initialValue_DeletedLineno = state.items_fetchOrdernoDetail[dataIndex]['LINENO']
            
            var tempCopy = [...state.items_fetchOrdernoDetail]
            
            //delete row
            tempCopy.splice(dataIndex, 1)

            //reorder lineno
            tempCopy.reduce( (previousValue, currentValue, currentIndex, array) => {
              let currentValueLineno = 'LINENO' in currentValue ? currentValue['LINENO'] : 0
                            
              if(currentIndex >= dataIndex && currentValueLineno > initialValue_DeletedLineno){
                tempCopy[currentIndex]['LINENO'] = currentValueLineno -1   
              }
              return currentValueLineno
            }, initialValue_DeletedLineno)

            return {
                ...state,
                items_fetchOrdernoDetail: [ 
                    ...tempCopy      
                ]    
            } 
        case FETCH_ORDERNOS_PRINT:
            // console.log("invoicesReducer FETCH_ORDERNOS_PRINT called");
            var print = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');

            for(var i in action.payload){
                console.log( 'action.payload[i]',  action.payload[i]['message'])
                orderDetailPrintPages(print, action.payload[i]['message']['ORDER_PROCESSING_DETAILS'], action.payload[i]['message']['HEADER'])
            }
            print.document.close();
            print.focus();
            setTimeout( function () {                
                print.print();
            }, 250);

            return {
                ...state,
                items_fetchOrdersPrint: action.payload
            }            
        // case VALIDATE_PARTNO:
        //     var initialValue_MaxLineno = state.items_fetchOrdernoDetail.length+1
        //     var maxLineNo = state.items_fetchOrdernoDetail.reduce( (previousValue, currentValue, currentIndex, array) => {
        //         let currentValueLineno = 'LINENO' in currentValue ? currentValue['LINENO'] : 0
        //         return Math.max(previousValue, currentValueLineno);                
        //     }, initialValue_MaxLineno)

        //     console.log('landingPageReducer VALIDATE_PARTNO maxLineNo:' + JSON.stringify(maxLineNo))

        //     return {
        //         // ...state,
        //         // items_fetchOrdernoDetail: [ 
        //         //     {
        //         //         'ORDERNO': state.items_fetchOrdernoDetail[0]['ORDERNO'],
        //         //         'USERID': state.items_fetchOrdernoDetail[0]['USERID'],
        //         //         'LINENO': maxLineNo + 1,
        //         //         'PRDID': '',
        //         //         'LINE': '',
        //         //         'PARTNO': '',
        //         //         'ORDERQTY': 0,
        //         //         'SHIPPEDQTY': 0,
        //         //         'CUSTID':  state.items_fetchOrdernoDetail[0]['CUSTID'],
        //         //         'USER_INPUT_QTY': 1,
        //         //         'QTY_TYPE': 'TO_INSERT'
        //         //     }
        //         //     ,...state.items_fetchOrdernoDetail
        //         // ]                
        //     }                         
        case SUBMIT_ORDER_RESPONSE:
            return {
                ...state,
            }                         
        case ORDER_TRANSFER_STATE_RESET:
            return initialOrderState;                             
        default:
            return state;
    }    
}

const customersReducer = (state = initialCustomerState, action) => {

    // console.log('customersReducer state', state)
    switch(action.type){
        case FETCH_CUSTOMERS:
            return {
                items_fetchCustomers: action.payload,
            }    
        case FETCH_CUSTNO_DETAIL:
            return {
                items_fetchCustnoDetail: action.payload['CUSTNO_DETAILS'],
                items_fetchCustCoreBank: action.payload['CUST_COREBANK'],
                items_fetchCorePickup: {},
            }
        case CORE_PICKUP:
            return {
                ...state,
                items_fetchCorePickup: action.payload
            }         
        case CUSTOMER_TRANSFER_STATE_RESET:
            return initialCustomerState;                             
        default:
            return state;
    }    
}

const inventoryReducer = (state = initialInventoryState, action) => {
    switch(action.type){
        case FETCH_INVENTORY:
            return {
                items_fetchInventory: action.payload,
            }    
        case FETCH_INVENTORY_DETAIL:
            return {
                items_fetchInventoryDetail: action.payload,  
                items_fetchInventoryDetailHeader: action.locheader           
            }
        // case UPDATE_INVENTORY_DETAIL_BIN:
        //     return {
        //         ...state,
        //         item_updatedBinResponse: action.payload,
        //     }
        case FETCH_INVENTORY_RESET:
            return initialInventoryState;                             
        default:
            return state;
    }    
}

const statusUpdateReducer = (state = initialStatusUpdates, action) => {
    // console.log('statusUpdateReducer state.items_statusErr: ' + JSON.stringify(state.items_statusErr))
    switch(action.type){
        case STATUS_NOTICE_MESSAGE:
            return {
                ...state,
                items_statusNotices: action.payload,                                
            }
        case STATUS_ERR_MESSAGE:
            return {
                ...state,
                items_statusErr: state.items_statusErr.concat(action.payload)
            }           
        case SUBMIT_ORDER_RESPONSE:
            return {
                ...state,
                orderServerResponse: action.payload
            }     
        case SUBMIT_TRANSFER_RESPONSE:        
            return { 
                ...state,
                transferServerResponse: action.payload
            }     
        case SUBMIT_CUST_CORE_RESPONSE:
            return {
                ...state,                                
                custServerResponse: action.payload
            }                                                            
        case STATUS_UPDATE_STATE_RESET:
            return initialStatusUpdates;                             
        default:
            return state;
    }    
}
export { transferReducer, orderTransferReducer, customersReducer, inventoryReducer, statusUpdateReducer };